import { render, staticRenderFns } from "./JobPageOverview.vue?vue&type=template&id=bfd6b14a&scoped=true&"
import script from "./JobPageOverview.vue?vue&type=script&lang=js&"
export * from "./JobPageOverview.vue?vue&type=script&lang=js&"
import style0 from "./JobPageOverview.vue?vue&type=style&index=0&id=bfd6b14a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd6b14a",
  null
  
)

export default component.exports